/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetStatisticsByContactsListResponseEntries } from './getStatisticsByContactsListResponseEntries';


export interface GetStatisticsByContactsListResponseDto { 
    dateStart?: string;
    dateEnd?: string;
    parentOrganisationId?: string;
    entriesCount?: number;
    entries?: Array<GetStatisticsByContactsListResponseEntries>;
}

